import React from "react"
import UploadImage from "@/components/VisualSearch/v1/UploadImage/index"
import Style from "@/components/VisualSearch/v1/CameraView/cameraview.module.scss"

const GuildePageMobile = props => {
  const {
    setShowInfo,
    category = "",
    setSection = () => {},
    setOutput = () => {},
    isUsingGlobalVS = false,
  } = props || {}
  return (
    <div
      className={`${Style.CameraView} ${
        isUsingGlobalVS && Style.CameraViewModalGVS
      }`}
    >
      <div className="cameraview-container">
        <UploadImage
          setShowInfo={setShowInfo}
          category={category}
          setSection={setSection}
          setOutput={setOutput}
          isUsingGlobalVS={isUsingGlobalVS}
        />
      </div>
    </div>
  )
}

export default GuildePageMobile
